/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleMasterManagementState.js'
//import mutations from './moduleUserManagementMutations.js'
import actions from './moduleMasterManagementActions.js'
//import getters from './moduleUserManagementGetters.js'
import { getField, updateField } from 'vuex-map-fields';
export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations: {
    SET_AGENTS (state,agents) {
      state.agents =  agents;
    },
    SET_MASTER (state, master) {
      state.master = master
    },
    SET_MASTERS (state, masters) {
      state.masters = masters
    },
    SET_POPUP (state, popup) {
      state.popup = popup;
    },
    updateField,
  },
  actions,
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
  },
}

